import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
    connect() {
        this.element.addEventListener('turbo:before-morph-attribute', this.preventAttributeMorph.bind(this))
    }

    preventAttributeMorph(event) {
        if (event.target !== this.element) {
            return
        }

        event.preventDefault()
    }
}
